import { serviceEstimates, serviceCategories, servicesDisclaimer } from '../data/services';
import { ui } from '../data/ui';
import { SEO } from '../components/ui/SEO';
import { SectionHeader } from '../components/ui/SectionHeader';
import { ScrollReveal } from '../components/ui/ScrollReveal';
import './ServicesPage.css';

export function ServicesPage() {
  return (
    <>
      <SEO title={ui.seo.services} description={ui.services.subtitle} />

      <div className="page-header">
        <div className="container">
          <SectionHeader
            label={ui.nav.services}
            title={ui.services.title}
            subtitle={ui.services.subtitle}
            align="center"
          />
        </div>
      </div>

      <section className="section">
        <div className="container">
          <ScrollReveal className="services-disclaimer glass-card">
            <p>{servicesDisclaimer}</p>
            <p className="disclaimer-note">{ui.services.disclaimerNote}</p>
          </ScrollReveal>

          {serviceCategories.map((category) => {
            const items = serviceEstimates.filter((s) => s.category === category);
            return (
              <div key={category} className="service-category">
                <ScrollReveal>
                  <h2 className="service-category-title">{ui.services.categories[category]}</h2>
                </ScrollReveal>
                <div className="service-grid">
                  {items.map((service, i) => (
                    <ScrollReveal key={service.id} delay={i * 0.05}>
                      <div className="service-card glass-card">
                        <div className="service-card-header">
                          <h3>{service.projectType}</h3>
                          <span className={`complexity-badge complexity-${service.complexity.toLowerCase().replace(' ', '-')}`}>
                            {ui.services.complexity[service.complexity]}
                          </span>
                        </div>
                        <div className="service-details">
                          <div className="service-detail">
                            <span className="detail-label">{ui.services.estimatedTime}</span>
                            <span className="detail-value">{service.estimatedTime}</span>
                          </div>
                          <div className="service-detail">
                            <span className="detail-label">{ui.services.estimatedRange}</span>
                            <span className="detail-value">{service.estimatedCostRange}</span>
                          </div>
                        </div>
                        <div className="service-features">
                          <span className="detail-label">{ui.services.typicalFeatures}</span>
                          <ul>
                            {service.typicalFeatures.map((feature) => (
                              <li key={feature}>{feature}</li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </ScrollReveal>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
}
